var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTelegram = function SvgTelegram(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 44c11.046 0 20-8.954 20-20S31.046 4 20 4 0 12.954 0 24s8.954 20 20 20Z",
    fill: "url(#telegram_svg__a)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m11.33 25.767 2.947 8.138s.369.762.764.762c.394 0 6.263-6.091 6.263-6.091L27.83 16l-16.395 7.666-.105 2.1Z",
    fill: "#C8DAEA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m11.427 26.087-6.06-1.978s-.724-.294-.49-.961c.047-.138.144-.255.434-.456 1.343-.937 24.853-9.4 24.853-9.4s.664-.224 1.055-.075a.572.572 0 0 1 .39.426c.042.175.06.355.053.536-.002.155-.02.3-.035.526-.143 2.314-4.428 19.582-4.428 19.582s-.257 1.01-1.175 1.045a1.68 1.68 0 0 1-1.226-.475c-1.803-1.553-8.033-5.746-9.41-6.668a.262.262 0 0 1-.113-.186c-.019-.098.087-.218.087-.218s10.848-9.657 11.137-10.67c.022-.08-.063-.118-.176-.083-.72.265-13.21 8.164-14.59 9.036a.663.663 0 0 1-.306.019Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "telegram_svg__a",
    x1: 20,
    y1: 44,
    x2: 20,
    y2: 4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D93D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#38B0E3"
  })))));
};
export default SvgTelegram;